import { truncate } from 'lodash';
import styled from '../styled';
import { MonitorBlogPageStats, MonitoredBlogWithStats } from '../types/Ranking';

export const TrendingPost = styled('div')`
  color: ${(p) => p.theme.palette.grey[400]};
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 24px;
  margin-top: ${(p) => p.theme.spacing(1)}px;
`;

const TrendingLinkWrapper = styled('a')`
  color: ${(p) => p.theme.palette.primary.main};
  font-size: 16px;
  border-bottom: 1px solid transparent;
  transition: border-bottom 0.1s ease-in;

  &:hover {
    border-bottom: 3px solid;
  }

  &:visited {
    color: #748499;
  }
`;

export const TrendingLink = ({
  blog,
  page
}: {
  blog: MonitoredBlogWithStats;
  page: MonitorBlogPageStats;
}) => {
  const url = new URL(blog.url);
  const origin = url.origin;

  if (!page) {
    console.warn(`No top page for ${url}, shouldn't have tried to render this`);
    return null;
  }

  return (
    <TrendingLinkWrapper
      href={`${origin}${page.pathname}`}
      target="_blank"
      rel="noopener"
    >
      {truncate(page.title || page.pathname, { length: 100 })}
    </TrendingLinkWrapper>
  );
};
